import { render, staticRenderFns } from "./LandingAd.vue?vue&type=template&id=cc55e020&"
import script from "./LandingAd.vue?vue&type=script&lang=js&"
export * from "./LandingAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports